import {
  difference, filter, uniq, xor,
} from 'lodash';

/**
 * Given a before and after map of collaborators, return the IDs of any collaborator that has been removed
 * @param  {any} before
 * @param  {any} after
 * @param  {any} mergeData
 * @return {string[]}
 */
export const resolveCollaborators = (before: string[] = [], after: string[] = [], mergeData?: string[]): string[] => {
  if (!mergeData || !Object.keys(mergeData).length) {
    return uniq(after);
  }

  if (!Array.isArray(before) && Array.isArray(after)) {
    return uniq(after);
  }

  const beforeIds = Object.keys(before);
  const afterIds = Object.keys(after);

  let diff = [];

  if (beforeIds.length > afterIds.length) {
    diff = difference(beforeIds, afterIds);
  }

  return uniq(filter(
    [...after, ...(!Array.isArray(mergeData) ? Object.keys(mergeData) : mergeData)],
    (collaboratorId) => diff.indexOf(collaboratorId) === -1,
  ));
};

/**
 * Determines if the two arrays are equal
 * @param  {any[]} array1
 * @param  {any[]} array2
 * @return {boolean}
 */
export const arraysEqual = (array1: unknown[], array2: unknown[]): boolean => xor(array1, array2).length === 0;

export const joinBy = <T extends string>(array: { [Key in T]: unknown }[], fieldName: T, separator: string) => {
  const mappedArray = array.map((value) => value[fieldName]);

  return mappedArray.join(separator);
};
